export const CURRENT_USER_LOADED = "user/usersLoaded"